<p>datepicker-month works!</p>
